export default "__VITE_ASSET__BvtWDd$d__"